import React, { FC, useEffect } from 'react';
import { WithTranslation, withTranslation } from '@wix/wix-i18n-config';
import cs from 'classnames';
import s from './mobileApp.scss';
import * as BIManager from '../../utils/bi';
import { MobileToolbar } from '../partials/MobileToolbar/MobileToolbar';
import { MobileEditorXToolbar } from '../partials/MobileEditorXToolbar/MobileEditorXToolbar';
import { fedopsLogger } from '../../utils/fedops-logger';
import { useTemplateContext } from '../../context/TemplateContext/TemplateContext';
import { useUIContext } from '../../context/UIContext/UIContext';
import { InfoButton } from '../InfoButton/InfoButton';
import { InfoPopUp } from '../InfoPopUp/InfoPopUp';

const MobileAppCmp: FC<WithTranslation> = ({ t }) => {
  const { isEditButtonHidden, isInfoShown } = useUIContext();
  const { template } = useTemplateContext();
  const { url, isResponsive, title } = template;
  const previewUrl = `${url}?showMobileView=true`;

  useEffect(() => {
    BIManager.reportLoadSuccess();
    if (template.isResponsive) {
      BIManager.reportResponsiveTemplateLoaded();
    }
    fedopsLogger.appLoaded();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-hooks="app">
      {isResponsive ? (
        [
          <MobileEditorXToolbar template={template} key="toolbar" isEditButtonHidden={isEditButtonHidden} />,
          <div className={s.goToBiggerScreen} key="bigger-screen" data-hooks="bigger-screen">
            {t('template.viewer.goToBiggerScreen')}
          </div>,
        ]
      ) : (
        <MobileToolbar>
          <InfoButton />
        </MobileToolbar>
      )}
      <iframe
        data-hooks="mobile-iframe"
        title={title}
        src={previewUrl}
        width="100%"
        height="100%"
        className={cs(s.iframe, { [s.iframeHidden]: isInfoShown })}
      />
      <InfoPopUp isMobile />
      {isResponsive && (
        <div className={s.seeAllExpressions} data-hooks="see-all-expressions">
          <a href="https://www.wix.com/editorx/templates" className={s.seeAllExpressionsLink}>
            <span className={s.seeAllExpressionsLinkText}>{t('template.viewer.seeAllExpressions')}</span>
            &nbsp;→
          </a>
        </div>
      )}
    </div>
  );
};

export const MobileApp = withTranslation()(MobileAppCmp);
